import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import AccordionSectionPresentationPropsDefault from "@insite/mobius/AccordionSection/presentationProps";
import { xBaseTheme } from "@stoneage/XDL/types";
import { color } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {},
    sectionDefaultProps: {
        ...AccordionSectionPresentationPropsDefault,
        css: css`
            padding: 8px;
        `,
        mergeCss: true,
        panelProps: {
            css: css`
                border: 0;
                font-size: 16px;
                background: ${color("common.white")};
            `,
        },
        headerProps: {
            css: css`
                & button {
                    padding: 8px;
                    background: ${color("common.ui4")};
                    border: 0;
                    &:focus {
                        border-width: 0 !important;
                        padding: 8px !important;
                        padding-left: 8px !important;
                    }
                }
            `,
        },
        toggleIconProps: {
            ...AccordionSectionPresentationPropsDefault?.toggleIconProps,
            color: "common.ui7",
            size: 12,
        },
    },
} as xBaseTheme["accordion"];
